(function(angular){
	'use strict';
	
	var blogFeedbackObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
		},
		controller: [
			'$window',
			'localStorageFactory',
			'mixpanelFactory', 
			BlogFeedbackFunction
		],
		controllerAs: 'blogFeedback'
	};
	
	angular
		.module('educationSiteModule')
		.component('blogFeedback', blogFeedbackObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/education-site/blog-feedback.html';
	}
	
	function BlogFeedbackFunction(
		$window,
		localStorageFactory,
		mixpanelFactory
	){
		var blogFeedback = this;
		var pageUrl = $window.location.pathname;
		var voteKey = pageUrl + '-voted';

		blogFeedback.vote = function(vote) {
			mixpanelFactory.track('Education Article Vote', {
				'Helpful': vote
			});

			blogFeedback.justVoted = true;
			localStorageFactory.setItem(voteKey, true);
		};

		blogFeedback.$onInit = function() {
			blogFeedback.alreadyVoted = angular.isDefined(localStorageFactory.getItem(voteKey));
		};
	}
})(window.angular);